import { z } from 'zod';
import { zStringRequired } from '../../z';
export const otPlanOfCareValidationSchema = z.object({
    id: z.string().optional(),
    data: z.object({
        treatmentPlan: z.object({
            otEval: z.string().optional(),
            patientAgrees: z.boolean().optional(),
            patientAgreesTo: z.string().optional(),
        }),
        rehabUpperExt: z.object({
            left: z.array(z.string()).optional(),
            right: z.array(z.string()).optional(),
        }),
        bodyExercise: z.object({
            cervical: z.object({
                prom: z.string().optional(),
                arom: z.string().optional(),
                isom: z.string().optional(),
                pre: z.string().optional(),
                stabilization: z.string().optional(),
            }),
            shoulder: z.object({
                prom: z.string().optional(),
                arom: z.string().optional(),
                isom: z.string().optional(),
                pre: z.string().optional(),
                stabilization: z.string().optional(),
            }),
            elbow: z.object({
                prom: z.string().optional(),
                arom: z.string().optional(),
                isom: z.string().optional(),
                pre: z.string().optional(),
                stabilization: z.string().optional(),
            }),
            forearm: z.object({
                prom: z.string().optional(),
                arom: z.string().optional(),
                isom: z.string().optional(),
                pre: z.string().optional(),
                stabilization: z.string().optional(),
            }),
            wrist: z.object({
                prom: z.string().optional(),
                arom: z.string().optional(),
                isom: z.string().optional(),
                pre: z.string().optional(),
                stabilization: z.string().optional(),
            }),
            handFingers: z.object({
                prom: z.string().optional(),
                arom: z.string().optional(),
                isom: z.string().optional(),
                pre: z.string().optional(),
                stabilization: z.string().optional(),
            }),
        }),
        cardiopulmonary: z.object({
            tolerance: z.string().optional(),
            activity: z.array(z.string()).optional(),
            monitor: z.array(z.string()).optional(),
            orders: z.array(z.string()).optional(),
            ordersFollow: z.string().optional(),
            breathingExercises: z.array(z.string()).optional(),
            energyTechnique: z.array(z.string()).optional(),
        }),
        painManagement: z.object({
            best: z.string().optional(),
            duringActivity: z.string().optional(),
            atRest: z.string().optional(),
            worst: z.string().optional(),
            techniques: z.array(z.string()).optional(),
        }),
        adliadl: z.object({
            safeTechnique: z.array(z.string()).optional(),
            compensatoryTechnique: z.array(z.string()).optional(),
            adaptiveTechnique: z.array(z.string()).optional(),
            activities: z.array(z.string()).optional(),
            activitiesOther: z.string().optional(),
        }),
        bedMobility: z.array(z.string()).optional(),
        bedMobilityAsstRequired: z.object({
            plof: z.string().optional(),
            clof: z.string().optional(),
            goal: z.string().optional(),
        }),
        manualTherapy: z.object({
            stm: z.string().optional(),
            mfr: z.string().optional(),
            jtMobs: z.string().optional(),
        }),
        gait: z.object({
            training: z.array(z.string()).optional(),
            sequencing: z.string().optional(),
            assistiveDevice: z.string().optional(),
            cadence: z.string().optional(),
            surfaces: z.string().optional(),
            baseSupport: z.string().optional(),
            wb: z.string().optional(),
            wbIndicate: z.array(z.string()).optional(),
            painfulGait: z.string().optional(),
            verbal: z.string().optional(),
            tactile: z.string().optional(),
            assistedDevice: z.string().optional(),
        }),
        transfers: z.object({
            notes: z.string().optional(),
            from: z.array(z.string()).optional(),
            fromProperTechnique: z.string().optional(),
            fromOther: z.string().optional(),
        }),
        balanceTransfer: z.array(z.string()).optional(),
        ptcgEducation: z.array(z.string()).optional(),
        frequencyOfVisits: z.object({
            noOfVisits: z.string().optional(),
            recurring: z.string().optional(),
            duration: z.string().optional(),
            otherDisciplineRecommend: z.array(z.string()).optional(),
            patientShowImprovement: z.string().optional(),
        }),
    }),
    signedUserId: zStringRequired(),
    signedUserDate: zStringRequired(),
});
